import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { MsgConfig } from 'src/app/app.messages';
import { FiltersEnum, IdentifierTypeEnum } from 'src/app/models/messaging.enum';
import { CommonService, ModalWrapperService, PatPreDrugModalService } from 'src/app/services';
import { UserService } from 'src/app/services/user.service';
import { WebPubSubService } from 'src/app/services/WebPubSubService';
import { AlertService } from "src/app/services";
import { PatientComponent } from '../../patient';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonUtil } from 'src/app/utils';
import { environment } from "src/environments/environment";
import { MessageService } from 'src/app/services/message.service';
import { Status } from '@sentry/browser';
import { get } from 'http';
@Component({
    selector: 'app-spc-cloud',
    styleUrls: ['./spc-cloud.component.css'],
    templateUrl: './spc-cloud.component.html',
    encapsulation: ViewEncapsulation.None
})
export class spcCloudComponent implements OnInit{
    @ViewChild('menuIcon', { static: true }) menuIcon!: ElementRef;   
    @ViewChild('popupMenu', { static: true }) popupMenu!: ElementRef;
    messages: any[] = [];
    enterMessage: any[] = [];
    userName: any;
    patientID: any;
    gender:any;
    activeInactive:boolean = false;
    @Input() userData: any;
    @Input() isFrmMessegingTab: any;
    selectedPeriod: string = FiltersEnum.ALLHISTORY;
    searchText: string = '';
    searchHistoryText: string = '';
    enteredMessage: string = '';
    placeholderMessage: string = MsgConfig.EnterMsg;
    npi:any;
    pharmacistName:any;
    resetMessages: boolean = false;
    isError: boolean = false;
    unsubscribe$: Subject<void> = new Subject();
    userSelected: boolean = false;
    patientInfo: any;
    patDOB: string;
    age: number;
    phoneNumber: any;
    isFrmMesTab:boolean = false;
    isIvrEnabled = environment.isIvrEnabled;
    searchDebounce = new Subject<string>();
    msgConfig = MsgConfig;
    sharedImages: string[] = []; 
    pharmacyName: string;
    sharedImagesMeta: any;
    pageNumber: number = 1;
    pageSize: number = 10;
    isMore: boolean = true;
    isLoadingMore: boolean = false;
    isImagesLoading: boolean;
    historyPreviewUrl: any;
    previewDoc: any;
    isHistoryPreviewOpen: boolean;
    previewFilename: any;
    previewDtTm: any;
    previewSize: string;
    zoom: number;
    zoomLevel: number = 100;
    @Input() ProfilePicDocId: any;
    profilePicUrl: string;
    @Output() PatientOffline: EventEmitter<boolean> = new EventEmitter<boolean>();
    patientPhn: any;
    IsPatientOnline: any;

    constructor(private cd: ChangeDetectorRef,
        private _webPubSubService: WebPubSubService,
        private _userServ: UserService,
        private ngZone: NgZone,
        private _commonServ:CommonService,
        private _alertService: AlertService,
        private _modalServ: ModalWrapperService,
         private _patPreDrugService: PatPreDrugModalService,
         private _comnUtil: CommonUtil,  private _msgServ: MessageService,
    ) { 
        this.searchDebounce.pipe(
            debounceTime(500),
            distinctUntilChanged()
        ).subscribe(searchText => {
            this.searchText = searchText;
        });
        
    }

    ngOnInit() {
        this.placeholderMessage = MsgConfig.EnterMsg;
        this.pharmacistName = this._commonServ.DecryptData(localStorage.getItem("PharmacistName"));
         this.pharmacyName = this._userServ.getToken("PharmacyName");
        this.npi = this._userServ.getToken("UniquePharmacyId");
        if(this.userData && this.userData?.identifier){
            this.onUserSelected(this.userData);
        } else{
            this.userSelected = false;
        }
        this.isFrmMesTab = this.isFrmMessegingTab ? this.isFrmMessegingTab : false;
        this.isIvrEnabled = environment.isIvrEnabled && localStorage.getItem("IvrGUIDDetails") ? true : false;
        if(this.isFrmMesTab){
            this.getInfo(true, false);
        }
    }

    onUserSelected(userData: any) {
        this.patientID = userData?.identifier;
        this.userName = userData?.userName;
        this.gender = userData?.gender;
        this.resetMessages = true;
        this.activeInactive = (userData?.identifier && userData) ? true : false;
        this.userSelected = false;
        this.IsPatientOnline = userData?.isLoggedIn;
        this.profilePicUrl = userData?.profilePicUrl;
        this.patientPhn = userData?.phoneNumber;
    }
    onEnter(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.sendMessage();
        }
    }
    routeToEditPatient(){
        const modalRef = this._modalServ.open(PatientComponent, {
            backdrop: false,
            size: "lg",
            windowClass: "md-xx-lg comp--modal modal-center-to-page modal-patient patientmodal-from-spc-cloud",
            keyboard: false
        });
        modalRef.componentInstance.patientID = this.patientID;
        modalRef.componentInstance.ClosePatientModal
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(resp => {
            if(resp){
                this.getInfo(false);
            }
            modalRef.close();
        });
    }

    routeToPatientHistory(){
        this._patPreDrugService._patPreDrugModal$.next("patHist");
        const modalRef = this._patPreDrugService.modalInstanceRef;
        modalRef.componentInstance.patientID = this.patientID;
        modalRef.componentInstance.popUpOpenFr = "rph";
        modalRef.componentInstance.IsPopUpClosed
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(resp => {
            if(resp){
                this.getInfo(false);
            }
            modalRef.close();
            this._patPreDrugService._patPreDrugModal$.next(null);
        });
    }
    closeInfo(){
        this.userSelected = false;
    }
    openInfo(){
        this.userSelected = this.patientID ? true : false;
        if(this.patientID){
            this.getInfo(false);
        }
         if(!this.isFrmMesTab){
            this.getImagesInfo();
        }
    }
    getInfo(callsendChatAlert, isFromChat?:any ) {
        this._commonServ.getEditPatientInformation(this.patientID).pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
            if(resp){
                this.patientInfo = resp;
                this.patDOB =  moment(this.patientInfo?.Person?.BirthDt).format(MsgConfig.DATE_FORMAT);
                this.age = this.calculateAge(this.patDOB);
                this.phoneNumber = this.patientInfo?.Phones?.find(x => x?.PhoneCatId === 2)?.xPhone;
                 if(callsendChatAlert) this.checkIsPatientOnline(isFromChat)
            }
        });
    }
    calculateAge(birthDate: string): number {
        return moment().diff(moment(birthDate, MsgConfig.DATE_FORMAT), 'years');
    }
    sendMessage(){
        if (!navigator.onLine) {
            this._alertService.error(MsgConfig.NO_Internet);
            this.enteredMessage = "";
            return;
        }
        if (!this.enteredMessage.trim()) { 
            this.isError = true;
            this.placeholderMessage = MsgConfig.PleaseEnterMsg;
            return;
        }
        this.resetMessages = false;
        this.isError = false;
        this.placeholderMessage = MsgConfig.EnterMsg;
        if (this.enteredMessage.trim() && this.patientID) {
            const enterMessage = {
                date: moment().toISOString(),
                message: this.enteredMessage,
                sender: {
                    identifier: this.npi,
                    identifierType: IdentifierTypeEnum.NPI,
                    userName: this.pharmacistName
                },
                lastMessageReceivedAt: new Date().toISOString(),
                IsRead: false
            };
            this._webPubSubService.sendMessageToPatient(this.npi, this.patientID, this.enteredMessage, this.pharmacistName, this.userName)
            .then(() => {
                this.enterMessage = [...this.enterMessage, enterMessage];
                this.cd.detectChanges();
                this.enteredMessage = '';
                this.ngZone.runOutsideAngular(() => {
                    requestAnimationFrame(() => {
                        this.scrollToBottom();
                    });
                });
              if(!this.IsPatientOnline){
                this.PatientOffline.emit(true)
                this.getInfo(true, true);
              }
            })
            .catch((error) => {
                console.error('Error sending message:', error);
            });
        } else {
            console.error('Message or PatientID is missing!');
        }
    }
    onFocus(): void { 
        if (this.isError) {
            this.isError = false;
            this.placeholderMessage = MsgConfig.EnterMsg;
        }
    }
    dateList = [
        { Name: FiltersEnum.ALLHISTORY, Id: FiltersEnum.ALLHISTORY },
        { Name: FiltersEnum.TODAY, Id: FiltersEnum.TODAY },
        { Name: FiltersEnum.LASTONEWEEK, Id: FiltersEnum.LASTONEWEEK },
        { Name: FiltersEnum.LASTONEMONTH, Id: FiltersEnum.LASTONEMONTH },
        { Name: FiltersEnum.LASTSIXMONTHS, Id: FiltersEnum.LASTSIXMONTHS },
        { Name: FiltersEnum.LASTONEYEAR, Id: FiltersEnum.LASTONEYEAR }
    ];
    togglePopup() { 
        const popupMenu = this.popupMenu.nativeElement;
        const computedStyles = window.getComputedStyle(popupMenu);
        const display = computedStyles.getPropertyValue('display'); 

        if (display === 'none') {
            const icon = this.menuIcon?.nativeElement;
            const position = icon.getBoundingClientRect();
            const top = position.bottom + window.scrollY - 10;
            let left = position.left - 90;
    
            const screenWidth = window.innerWidth;
            if (screenWidth <= 720) {
            left -= 14;
            }
            popupMenu.style.display = 'block';
            popupMenu.style.top = `${top}px`;
            popupMenu.style.left = `${left}px`;
        } else { 
            popupMenu.style.display = 'none';
        }
    }

    ngAfterViewInit() {
        document.addEventListener('click', (event) => this.onClick(event));
    }
    
    onClick(event: MouseEvent) {
        if (this.popupMenu?.nativeElement && this.menuIcon?.nativeElement) {
            const popupMenu = this.popupMenu.nativeElement;
            const menuIcon = this.menuIcon.nativeElement; 
            if (!menuIcon.contains(event.target) && !popupMenu.contains(event.target)) {
                popupMenu.style.display = 'none';
            }
        }
    }
    showSection(period:any){
        this.selectedPeriod = period;
        this.cd.detectChanges(); 
        this.closeFilter();
    }

    closeFilter() {
        if(this.popupMenu?.nativeElement){
            const popupMenu = this.popupMenu.nativeElement;
            popupMenu.style.display = 'none';
        }
    }

    onSearch(event: any): void {
        this.searchDebounce.next(event.target.value);
    }

    onHistorySearch(event: any): void {
        this.searchHistoryText = event?.target?.value?.trim();
    }
    scrollToBottom() {
        const chatHistory = document.querySelector('.chat-history');
        if (chatHistory) {
            chatHistory.scrollTop = chatHistory.scrollHeight;
        }
    }

    async clickToCallOutBond(mobile) {
        let resp;
        let callRequest = this._comnUtil.clickToOutBondcall(mobile);
        let patDetails = { PatientName : this.userName, patientid: this.patientID, dob:this.patDOB, phoneNumber:mobile, gender:this.gender, addressLine1:this.patientInfo?.Addresses?.AddressLine1, state:this.patientInfo?.Addresses?.StateName, city:this.patientInfo?.Addresses?.CityName, zipCode:this.patientInfo?.Addresses?.ZipCode }
        if(callRequest && mobile && this.isIvrEnabled) {
            if(callRequest?.ivrVendor === 1) {
                resp = await this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                if(resp) this._comnUtil.openCallLogPopup(mobile,patDetails,'Patient');
                else { this._alertService.error(MsgConfig.IVR_Call_Error); this._commonServ._isCallOngoing$.next(null); }
            } else if(callRequest?.ivrVendor === 2) {
                this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                this._comnUtil.openCallLogPopup(mobile,patDetails,'Patient');
            } 
        }        
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    viewImage(url: string) {
    window.open(url, '_blank', 'noopener');
    }


async getImagesInfo() {
  this.pageNumber = 1;
  this.isMore = true;
  this.sharedImagesMeta = []; // reset only first time load
  await this.loadMoreImages();
}

async loadMoreImages(){
  if(this.isLoadingMore || !this.isMore) return;

  this.isLoadingMore = true;
  this.isImagesLoading = true; // start loader non blocking

  const payload = {
    Pharmacy: {
      IdentifierType: 0,
      Identifier: String(this.patientID) + "_" + String(this.npi),
      Name: this.pharmacyName,
    },
    Application: { Id: 1, Name: "Primerx" },
    Status: 1,
    RelatedEntity: {
      EntityType: 0,
      Identifier: String(this.patientID),
      Name: this.userName,
    },
    DocumentReference: 2,
    PageNumber: this.pageNumber,
    PageSize: this.pageSize
  };

  const resp: any = await this._msgServ.paginatedImages(payload).toPromise(); // async, UI not blocked

if(resp?.documents){
    const newData = resp.documents.map(x => {
      return {
        url: x.url,
        name: x.name,
        sizeMb: x.sizeInMb,
        created: moment(x.creationDateTime).format("MMM DD, h:mm A")
      }
    });

    // append
    this.sharedImagesMeta = [...this.sharedImagesMeta, ...newData];

    // REAL stop condition
    if(newData.length === 0){
      this.isMore = false;   // no more calls
    } else {
      this.pageNumber++;     // only increment if something came
    }
}


  this.isImagesLoading = false; // stop loader UI
  this.isLoadingMore = false;
  this.cd.detectChanges();
}

onScroll(e:any){
  const el = e.target;
  if(el.scrollTop + el.clientHeight >= el.scrollHeight - 5){
    this.loadMoreImages();
  }
}
downloadImg(img: any) {
    this._comnUtil.downloadFile(img);
}
openHistoryPreview(doc: any) {
  this.historyPreviewUrl = doc?.url;
  this.previewDoc = doc;
  this.isHistoryPreviewOpen = true;
 this.previewFilename = doc?.name;
  this.previewDtTm = doc?.created;
  this.previewSize = (doc?.sizeMb)?.toFixed(2) + ' MB';
  this.zoom = 1;  
  document.body.style.overflow = 'hidden';
}
closeHistoryPreview(): void {
  this.isHistoryPreviewOpen = false;
  this.historyPreviewUrl = null;
  this.previewFilename = null;
  this.zoom = 1;
  this.zoomLevel = 100;
  document.body.style.overflow = '';
}
zoomIn(): void {
  if (this.zoomLevel < 300) {
    this.zoomLevel += 10;
    this.zoom = this.zoomLevel / 100;
  }
  const imgEl = document.querySelector('.spc-lightbox__image') as HTMLElement;
  if (imgEl) {
    imgEl.style.transition = 'transform 0.2s ease';
    imgEl.style.transformOrigin = 'center center';
    imgEl.style.transform = `scale(${this.zoom})`;
  }
}

zoomOut(): void {
  if (this.zoomLevel > 10) {
    this.zoomLevel -= 10;
    this.zoom = this.zoomLevel / 100;
  }
}
onProfilePicUrl(url: string) {
  this.profilePicUrl = url;
}
checkIsPatientOnline(isFromChat:boolean){
    const mobile = this.patientInfo?.Phones?.find(p => p.PhoneCatId === 2);
    const payload =    {
        PersonId: this.patientInfo?.Patient?.Id,
        EntityId: this.patientInfo?.Patient?.Id,
        MessageCatId: 0,
        PatientName: this.patientInfo?.Person?.FirstName,
        ToNumber:  mobile ? mobile.xPhone : '',
        Subject: '',
        IsFromChat: isFromChat
    };

    this._msgServ.isPatientOnline(payload).subscribe((res: any) => {
        this.IsPatientOnline = res?.IsLoggedIn;
        if(res?.IsAlertSent){
            this.resetMessages = true;
        }
    })
}
}
